<template>
    <div class="header-contain" :class="isHome ? '' : 'bg'">
        <!--左侧-->
        <div class="left-header">
            <div class="left-header-time">{{ leftHeaderTime }}</div>
            <div class="left-header-date">
                <span>{{ week }}</span
                ><span>{{ leftHeaderDate }}</span>
            </div>
            <div v-if="!isHome && !isScenicSpot && !isVideoAnalysis" class="left-header-update">
                {{ leftHeaderUpdate }}更新
            </div>
        </div>
        <!--右侧-->
        <div class="right-header">
            <div class="right-header-name">欢迎您，{{ userInfo.name }}</div>
            <div class="right-header-back" @click="goBack" v-if="!isHome">
                <i class="iconfont icon-fanhuishangji"></i><span>返回上级</span>
            </div>
            <div class="right-header-out" @click="logOut">
                <i class="iconfont icon-tuichuzhanghao"></i><span>退出</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeToken, removeRefreshToken } from "@/utils/auth";
export default {
    name: "pageHeader",
    props: {
        isHome: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        isScenicSpot:{
            type: Boolean,
            default: () => {
                return false;
            }
        },
        isVideoAnalysis:{
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
    data() {
        return {
            time: "",
            name: ""
        };
    },
    computed: {
        ...mapGetters(["userInfo"]),
        leftHeaderTime: function() {
            let date = this.time.split(" ");
            return date[1];
        },
        week: function() {
            return this.$util.getWeek();
        },
        leftHeaderDate: function() {
            let date = this.time.split(" ");
            return date[0];
        },
        leftHeaderUpdate: function() {
            let date = this.time.split(" ")[1] || "";
            date = date.slice(0, date.indexOf(":")) + "点";
            return date;
        }
    },
    created() {
        console.log("当前登录用户：", this.userInfo);
        const timer = setInterval(() => {
            this.getTime();
        }, 500);
        this.$once("hook:beforeDestroy", () => clearInterval(timer));

        // this.name = localStorage.getItem("login_user").name;
    },
    methods: {
        getTime() {
            this.time = this.$util.dateFormat(new Date());
        },
        goBack() {
            // this.$router.go(-1);
            this.$router.back();
        },
        logOut() {
            // 待有争议 s
            // removeToken()
            // removeRefreshToken()
            // localStorage.removeItem("login_user");
            this.$confirm("确认退出当前用户，是否继续？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.$store.commit("userInfo/logOut");
                    this.$router.push("/");
                })
                .catch(() => {});

            // 待有争议 e
            // this.$router.push('/')
            // window.close();
        }
    }
};
</script>

<style lang="scss" scoped>
.bg {
     background: url("https://vtzn.oss-cn-zhangjiakou.aliyuncs.com/%E8%BE%BE%E5%B0%94%E5%AE%97%E6%B9%96%E9%A1%B5%E5%A4%B4.png")
         center/100% 100% no-repeat;
}
.header-contain {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0 vw(57) vh(75) vw(67);
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    // box-shadow: 0px 33px 62px 0px #160D04;
    font-family: Source-Regular;
    color: rgba(161, 198, 255, 1);
    // background: url("https://vtzn.oss-cn-zhangjiakou.aliyuncs.com/bwg/20211207/内页标题_1638860200104.gif")
    //   center/100% 100% no-repeat;

    .left-header,
    .right-header {
        display: flex;
        align-items: flex-end;
    }
    .left-header {
        font-size: vw(14);
        line-height: vw(21);
        .left-header-time {
            font-size: vw(30);
            line-height: vw(33);
        }
        .left-header-date {
            margin: 0 vw(15) 0 vw(30);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
    }
    .right-header {
        color: rgba(195, 225, 255, 1);
        font-size: vw(14);
        line-height: vw(21);
        .right-header-back,
        .right-header-out {
            cursor: pointer;
            margin: 0 vw(16);
        }
        .right-header-back {
            margin: 0 vw(25) 0 vw(23);
        }
        i {
            margin-right: vw(2);
            font-size: vw(16);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pageHeader/pageHeader.vue